module.exports = __webpack_public_path__ + "img/linkedin-color.60f4a215.svg";